import type { SearchCategory } from '~/shared/interfaces/search'

export const SEARCH_MIN_QUERY_LENGTH = 3
export const SEARCH_DEBOUNCE_MS = 300
export const SEARCH_RESULTS_PER_CATEGORY = 3

export const EXCLUDED_SEARCH_CATEGORIES: readonly string[] = ['courses']

export const SEARCH_CATEGORY_LABELS: Record<SearchCategory, string> = {
  'vacancies': 'Вакансии',
  'news': 'Новости',
  'books': 'Книги',
  'universities': 'Университеты',
  'employers': 'Компании',
  'colleges': 'Колледжи',
  'professional-education': 'Дополнительное образование',
}

export const SEARCH_CATEGORY_ICONS: Record<SearchCategory, string> = {
  'vacancies': 'fluent/document-text-20-regular',
  'news': 'fluent/news-20-regular',
  'books': 'fluent/book-open-20-regular',
  'universities': 'fluent/building-20-regular',
  'employers': 'fluent/building-20-regular',
  'colleges': 'fluent/building-20-regular',
  'professional-education': 'fluent/building-20-regular',
}
